import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthQuery } from '../../state/auth.query';
import { AuthStore } from '../../state/auth.store';

@Injectable({ providedIn: 'root' })
export class LoginGuard implements CanActivate {
  constructor(
    private readonly authQuery: AuthQuery,
    private readonly authStore: AuthStore,
    private readonly router: Router,
  ) {}

  canActivate() {
    const redirectUrl = this.getRedirectUrlAfterLogin();

    console.debug(`[LoginGuard]: redirecting to ${redirectUrl}`);

    return this.router.parseUrl(redirectUrl);
  }

  private getRedirectUrlAfterLogin(): string {
    const redirectUrl = this.authQuery.getRedirectUrlAfterLogin();
    let url = '/';

    if (redirectUrl) {
      this.authStore.setRedirectUrlAfterLogin(null);
      url = redirectUrl;
    }

    if (['/login', '/logout'].includes(url)) {
      return '/';
    }

    return url;
  }
}
